// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"fab7c884","663":"e8951743"}[chunkId] + ".chunk.js";
};